(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sections-vello-landing"] && !Shopify.designMode) return;
  try {
    
/* =========================================================
   Vello Co — minimal vanilla JS
   Mobile menu · FAQ accordion · product selector ·
   quantity · live price · sticky purchase bar
   No fake carts, counters, timers or pop-ups.
   ========================================================= */
(function () {
  "use strict";

  /* ----- Helpers ----- */
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* PRICE FORMATTING — radio inputs carry real data-price values rendered from Shopify variant prices. */
  var CURRENCY = "£";
  function isRealNumber(v) { return v != null && v !== "" && !isNaN(parseFloat(v)) && isFinite(v); }
  function formatMoney(n) { return CURRENCY + (Math.round(n * 100) / 100).toFixed(2); }

  /* ----- Mobile menu ----- */
  (function initMenu() {
    var toggle = $("#navToggle");
    var menu = $("#navMenu");
    if (!toggle || !menu) return;

    function close() {
      menu.classList.remove("is-open");
      toggle.setAttribute("aria-expanded", "false");
    }
    toggle.addEventListener("click", function () {
      var open = menu.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
    // Close when a link is chosen or on Escape
    menu.addEventListener("click", function (e) {
      if (e.target.closest("a")) close();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") close();
    });
  })();

  /* ----- FAQ accordion (accessible) ----- */
  (function initFaq() {
    var buttons = $$(".faq__q");
    buttons.forEach(function (btn) {
      var panel = document.getElementById(btn.getAttribute("aria-controls"));
      if (!panel) return;
      btn.addEventListener("click", function () {
        var expanded = btn.getAttribute("aria-expanded") === "true";
        btn.setAttribute("aria-expanded", expanded ? "false" : "true");
        panel.hidden = expanded;
      });
    });
  })();

  /* ----- Product selector + quantity + live price + sticky bar ----- */
  (function initBuy() {
    var optionSet = $("#optionSet");
    var qtyInput = $("#qtyInput");
    var qtyMinus = $("#qtyMinus");
    var qtyPlus = $("#qtyPlus");
    var totalEl = $("#offerTotal");
    var buyBtn = $("#buyBtn");
    var priceLabels = $$("[data-price-label]");

    var stickyBar = $("#stickyBar");
    var stickyName = $("#stickyName");
    var stickyPrice = $("#stickyPrice");
    var stickyBuy = $("#stickyBuy");
    var offerSection = $("#offer");

    if (!optionSet) return;

    function selected() { return $("input[name=product]:checked", optionSet); }
    function qty() { return Math.max(1, parseInt(qtyInput.value, 10) || 1); }

    function currentLabelText(input) {
      // The visible placeholder label sits in the same option body
      var body = input.closest(".option");
      var label = body ? body.querySelector("[data-price-label]") : null;
      return label ? label.textContent.trim() : "";
    }
    function currentName(input) {
      var body = input.closest(".option");
      var name = body ? body.querySelector(".option__name") : null;
      // Strip any badge text
      return name ? name.firstChild.textContent.trim() : input.value;
    }

    function update() {
      var input = selected();
      if (!input) return;
      var priceAttr = input.getAttribute("data-price");
      var n = qty();
      var display;

      if (isRealNumber(priceAttr)) {
        var unit = parseFloat(priceAttr);
        display = formatMoney(unit * n);
      } else {
        // Fallback: show the visible label, note qty honestly.
        var label = currentLabelText(input);
        display = n > 1 ? label + " × " + n : label;
      }

      if (totalEl) totalEl.textContent = display;

      // Build Shopify cart permalink from the selected variant + quantity
      var vid = input.getAttribute("data-variant-id");
      if (buyBtn && vid) buyBtn.setAttribute("href", "/cart/" + vid + ":" + n);
      var offerImg = document.getElementById("offerImage");
      var imgUrl = input.getAttribute("data-image");
      if (offerImg && imgUrl) offerImg.src = imgUrl;
      var offerNote = document.getElementById("offerImageNote");
      var noteTxt = input.getAttribute("data-note");
      if (offerNote && noteTxt) offerNote.textContent = noteTxt;

      // Button label reflects the chosen option
      if (buyBtn) {
        buyBtn.textContent = input.value === "bundle"
          ? "Buy the Complete System"
          : "Buy now";
      }

      // Sticky bar mirrors the selection
      if (stickyName) stickyName.textContent = currentName(input);
      if (stickyPrice) stickyPrice.textContent = display;
    }

    optionSet.addEventListener("change", update);

    if (qtyMinus) qtyMinus.addEventListener("click", function () {
      qtyInput.value = Math.max(1, qty() - 1); update();
    });
    if (qtyPlus) qtyPlus.addEventListener("click", function () {
      qtyInput.value = Math.min(20, qty() + 1); update();
    });

    // Sticky "Choose & buy" scrolls to the offer so the shopper can pick an option
    if (stickyBuy) stickyBuy.addEventListener("click", function (e) {
      e.preventDefault();
      if (offerSection) offerSection.scrollIntoView({ behavior: "smooth", block: "start" });
    });

    /* Show sticky bar only after the hero scrolls away and hide it over the offer */
    (function stickyVisibility() {
      if (!stickyBar) return;
      function onScroll() {
        var y = window.pageYOffset || document.documentElement.scrollTop;
        var pastHero = y > 520;
        var overOffer = false;
        if (offerSection) {
          var r = offerSection.getBoundingClientRect();
          overOffer = r.top < window.innerHeight && r.bottom > 0;
        }
        stickyBar.hidden = !(pastHero && !overOffer);
      }
      var ticking = false;
      window.addEventListener("scroll", function () {
        if (!ticking) { window.requestAnimationFrame(function () { onScroll(); ticking = false; }); ticking = true; }
      }, { passive: true });
      onScroll();
    })();

    update();
  })();

  /* ----- Reviews show-more ----- */
  (function initReviewsMore() {
    var grid = $("#reviewsGrid");
    var btn = $("#reviewsMoreBtn");
    if (!grid || !btn) return;
    btn.addEventListener("click", function () {
      var expanded = grid.classList.toggle("is-expanded");
      btn.setAttribute("aria-expanded", expanded ? "true" : "false");
      btn.textContent = expanded ? "Show fewer reviews" : "Show all 10 reviews";
    });
  })();

  /* ----- Footer year ----- */
  (function initYear() {
    var y = $("#year");
    if (y) y.textContent = new Date().getFullYear();
  })();

})();


  } catch(e) { console.error(e); }
})();
})();
